// extracted by css-extract-rspack-plugin
export default {"commit-discussion-comments":"Comment-module__commit-discussion-comments___VBnj","discussion-comments-rose":"Comment-module__discussion-comments-rose__sMl1p"};